<template>
    <div style="width:100%;">
        <canvas :name="name" style="width:100%;" />
    </div>
</template>

<script>
    import moment from 'moment';

    const defaultStrokeColor = 'green';
    let margin = 30;

    function setpixelated(context){
        context['imageSmoothingEnabled'] = false;       /* standard */
        context['mozImageSmoothingEnabled'] = false;    /* Firefox */
        context['oImageSmoothingEnabled'] = false;      /* Opera */
        context['webkitImageSmoothingEnabled'] = false; /* Safari */
        context['msImageSmoothingEnabled'] = false;     /* IE */
    }

    export default {
        name: "counter",

        props: ['name', 'value', 'max', 'color', 'type', 'legend', 'compact'],

        data(){
            return{

            }
        },

        watch: {
            value(newValue, oldValue){

                if(this.value < 0 || this.value > this.max){
                    return;
                }

                this.draw();
            }
        },

        methods:{
            draw(){
                let c = document.getElementsByName(this.name)[0];
                let ctx = c.getContext('2d');

                if(this.compact === true) {
                    c.height = 30;
                }
                else{
                    c.height = c.width + margin;
                }

                // заливка белым
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, c.width, c.height);

                let dx = this.value / this.max;

                if(this.compact === true){
                    // ctx.beginPath();
                    // ctx.rect(margin/2, 20, c.width - margin, margin);
                    // ctx.lineWidth = 0;
                    // ctx.strokeStyle = '#FFF';
                    // ctx.stroke();

                    ctx.beginPath();
                    ctx.rect(margin/2, 10, c.width * dx - margin, margin);
                    ctx.lineWidth = 2;
                    ctx.strokeStyle = this.color;
                    ctx.fillStyle = this.color;
                    ctx.stroke();
                    ctx.fill();

                    this.drawValue();
                }
                else {
                    let minSize = Math.min(c.width, c.height);
                    let x = c.width / 2,
                        y = c.height / 2 ,
                        radius = minSize / 2 - margin;

                    // основной контур
                    ctx.beginPath();
                    ctx.arc(x, y, radius, -1.5 * Math.PI, 1.5 * Math.PI);
                    ctx.lineWidth = 2;
                    ctx.strokeStyle = '#eaebf0';
                    ctx.stroke();

                    // подсвеченный
                    let dxPI = dx * Math.PI * 2.0;
                    let endAngle = 1.5 * Math.PI + dxPI;

                    ctx.beginPath();
                    ctx.arc(x, y, radius, 1.5 * Math.PI, endAngle);
                    ctx.strokeStyle = this.color || defaultStrokeColor;
                    ctx.stroke();

                    // выводим значение
                    this.drawValue();

                    // подписи под счётчиком
                    this.drawLegend();
                }

            },

            drawLegend(){
                let c = document.getElementsByName(this.name)[0];
                let ctx = c.getContext('2d', {alpha: false});
                setpixelated(ctx);

                ctx.font = "18px Segoe UI";
                ctx.fillStyle = '#728a9a';
                ctx.textAlign = 'center';
                ctx.fillText(this.legend, c.width / 2, c.height - 10);
            },

            drawValue(){
                let c = document.getElementsByName(this.name)[0];
                let ctx = c.getContext('2d');

                ctx.font = "22px Segoe UI";
                ctx.fillStyle = '#000';
                ctx.textAlign = 'center';
                let x =c.width / 2;

                if(this.compact === true){
                    ctx.textAlign = 'left';
                    x = margin;
                    ctx.font = "12px Segoe UI";
                }

                ctx.fillText(this.getValueToDisplay(), x, c.height / 2 + 8);
            },

            getValueToDisplay(){
                let valueToDisplay = '';
                if(this.value === 0){
                    valueToDisplay = '0';
                }
                else {
                    if (this.type === 'time') {

                        let d1 = new Date();
                        let d2 = new Date();
                        d2.setSeconds(d2.getSeconds() + this.value);

                        const diff = moment.duration(d2 - d1);

                        let m = diff.minutes(),
                            s = diff.seconds();

                        valueToDisplay = `${m >= 10 ? m : '0' + m}:${s >= 10 ? s : '0' + s}`;
                    }
                    else {
                        valueToDisplay = this.value.toFixed(0);
                    }
                }

                if (this.compact === true) {
                    valueToDisplay = this.legend + ': ' + valueToDisplay;
                }

                return valueToDisplay;
            }
        },

        mounted () {
            this.draw();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/BaseCounter.vue